export const ACCOUNT_BILLING_DEFAULT_EXPANSION_BILL_COUNT = 3;

export enum BillingGrouping {
    Month = 'Month',
    Reservation = 'Reservation',
}

export const BILLING_EVENT_CATEGORY = 'Billing';

export enum BillingMode {
    ReservationBilling = 'ReservationBilling',
    AccountBilling = 'AccountBilling',
}

export enum BillClassification {
    Owned = 'Owned',
    Associated = 'Associated',
}

export enum BillManipulationMode {
    MoveBill = 'moveBill',
    MoveItems = 'moveItems',
}
